module.exports = __webpack_public_path__ + "img/pdf_ativo.f2ad74b1.svg";